(() => {
  if (window.fsbBaseReady) return;
  window.fsbBaseReady = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      if (!motion.matches && !window.Shopify?.designMode) entry.target.classList.add('fsb-revealed');
      observer.unobserve(entry.target);
    }
  }, {threshold:.08}) : null;
  const init = (root = document) => {
    root.querySelectorAll('[data-fsb-reveal]').forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      observer?.observe(el);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-fsb-reveal]').forEach(el => observer?.unobserve(el)));
  const header = document.querySelector('.section-header');
  if (header && 'ResizeObserver' in window) new ResizeObserver(() => document.documentElement.style.setProperty('--fsb-header-height', `${header.offsetHeight}px`)).observe(header);
  let scheduled = false;
  const scroll = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { document.body.classList.toggle('fsb-scrolled', scrollY > 30); scheduled = false; });
  };
  addEventListener('scroll', scroll, {passive:true});
  scroll();
  // Dawn owns focus trapping, Escape, return focus, and scroll locking.
  // Add explicit dialog semantics only while its menu details is open.
  const drawerInit = () => {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer || drawer.dataset.fsbDialog) return;
    drawer.dataset.fsbDialog = 'true';
    const update = () => {
      if (drawer.open) {
        drawer.setAttribute('role','dialog');
        drawer.setAttribute('aria-modal','true');
        drawer.setAttribute('aria-label',drawer.querySelector('summary')?.getAttribute('aria-label') || 'Menu');
      } else ['role','aria-modal','aria-label'].forEach(attr => drawer.removeAttribute(attr));
    };
    drawer.addEventListener('toggle',update);
    update();
  };
  drawerInit();
  document.addEventListener('shopify:section:load',drawerInit);
})();
